import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IClientDetailsActions, IThunkGetPhone } from '../types';

const onGetPhone: IThunkGetPhone = thunk(
  async ({ setCurrent }: Actions<IClientDetailsActions>, payload) => {
    const current = await api.clientDetails.getClientPhone(payload).then(r => r.data);

    setCurrent(current);
  },
);

export default onGetPhone;
